import IcoEmail from "../icons/IcoEmail";
import IcoPerson from "../icons/IcoPerson";
import IcoPhone from "../icons/IcoPhone";
import "../Dashboard.css";

export default function Header({ myProfile, myAccounting }) {
  return (
    <div className="w-full bg-white px-4 py-9 mt-4">
      <div className="title-area">
        <h1>Your Accounting Information</h1>
      </div>
      <div className="info-container">
        {myAccounting && (
          <>
            <div className="accounting-item">
              <div
                className="accounting-header"
                style={{ color: "var(--Warning-Color---Red, #F44)" }}
              >
                Past Due Amount
              </div>
              <div
                className="accounting-data"
                style={{ color: "var(--Warning-Color---Red, #F44)" }}
              >
                {(() => {
                  const amount = myAccounting?.pastDueAmount ?? 0;

                  if (amount === 0) return "$0";

                  const value = Math.abs(amount).toFixed(2);
                  return amount < 0 ? `-$${value}` : `$${value}`;
                })()}
              </div>
            </div>
            <div className="accounting-item">
              <div
                className="accounting-header"
                style={{ color: "var(--Base-White, #FFF)" }}
              >
                Credit Limit
              </div>
              <div className="accounting-data">${myAccounting.creditLimit}</div>
            </div>
            <div className="accounting-item">
              <div
                className="accounting-header"
                style={{ color: "var(--Base-White, #FFF)" }}
              >
                Current Amount
              </div>
              <div className="accounting-data">
                {(() => {
                  const amount = myAccounting?.currentAmount ?? 0;

                  if (amount === 0) return "$0";

                  const value = Math.abs(amount).toFixed(2);
                  return amount < 0 ? `-$${value}` : `$${value}`;
                })()}
              </div>
            </div>
            <div className="accounting-item">
              <div
                className="accounting-header"
                style={{ color: "var(--Base-White, #FFF)" }}
              >
                Total Invoiced Amount
              </div>
              <div className="accounting-data">
                {(() => {
                  const amount = myAccounting?.totalAmount ?? 0;

                  if (amount <= 0) return "$0";

                  return `$${amount.toFixed(2)}`;
                })()}
              </div>
            </div>
            <div className="accounting-item">
              <div
                className="accounting-header"
                style={{ color: "var(--Base-White, #FFF)" }}
              >
                Available Credit Amount
              </div>
              <div className="accounting-data">
                {(() => {
                  const amount = myAccounting?.creditBalance ?? 0;

                  if (amount === 0) return "$0";

                  const value = Math.abs(amount).toFixed(2);
                  return amount < 0 ? `-$${value}` : `$${value}`;
                })()}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
